/* eslint-disable no-dupe-keys */
export default {
  charging_card_consumption_record: {
    name: '充电卡消费记录',
    // 属性（一般与对象内容匹配）
    prop: {
      charging_card: '充电卡',
      charging_card_amount: '充电卡初始金额',
      trade_number: '订单号',
      charge_station: '充电站',
      order: '订单',
      order_amount: '订单金额',
      user: '用户',
      consumption_amount: '消费金额',
      before_consumption_amount: '消费前卡余额',
      after_consumption_amount: '消费后卡余额',
      created_at: '消费时间'
    },
    // Enum的属性
    // Boolean的属性
    // 占位提示
    placeholder: {
      search_keyword: '查询订单号/充电卡名'
    }
    // 详情页标签
    // 标题
  }
}
